__turbopack_context__.v({
  "containerLogos": "CX_FHG_containerLogos",
  "instituicoes": "CX_FHG_instituicoes",
  "itemLogo": "CX_FHG_itemLogo",
  "titleArea": "CX_FHG_titleArea",
});
